(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/objectWithoutProperties", "@babel/runtime/helpers/objectSpread", "@babel/runtime/helpers/classCallCheck", "@babel/runtime/helpers/createClass", "@babel/runtime/helpers/possibleConstructorReturn", "@babel/runtime/helpers/getPrototypeOf", "@babel/runtime/helpers/assertThisInitialized", "@babel/runtime/helpers/inherits", "@babel/runtime/helpers/defineProperty", "react", "prop-types", "../../context"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/objectWithoutProperties"), require("@babel/runtime/helpers/objectSpread"), require("@babel/runtime/helpers/classCallCheck"), require("@babel/runtime/helpers/createClass"), require("@babel/runtime/helpers/possibleConstructorReturn"), require("@babel/runtime/helpers/getPrototypeOf"), require("@babel/runtime/helpers/assertThisInitialized"), require("@babel/runtime/helpers/inherits"), require("@babel/runtime/helpers/defineProperty"), require("react"), require("prop-types"), require("../../context"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.objectWithoutProperties, global.objectSpread, global.classCallCheck, global.createClass, global.possibleConstructorReturn, global.getPrototypeOf, global.assertThisInitialized, global.inherits, global.defineProperty, global.react, global.propTypes, global.context);
    global.unknown = mod.exports;
  }
})(this, function (_exports, _objectWithoutProperties2, _objectSpread2, _classCallCheck2, _createClass2, _possibleConstructorReturn2, _getPrototypeOf3, _assertThisInitialized2, _inherits2, _defineProperty2, _react, _propTypes, _context) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _objectWithoutProperties2 = _interopRequireDefault(_objectWithoutProperties2);
  _objectSpread2 = _interopRequireDefault(_objectSpread2);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf3 = _interopRequireDefault(_getPrototypeOf3);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);

  var InnerPg =
  /*#__PURE__*/
  function (_React$Component) {
    (0, _inherits2.default)(InnerPg, _React$Component);

    function InnerPg() {
      var _getPrototypeOf2;

      var _this;

      (0, _classCallCheck2.default)(this, InnerPg);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(InnerPg)).call.apply(_getPrototypeOf2, [this].concat(args)));
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", function () {
        var core = _this.grid.core;

        if (core && core.emitter) {
          core.emitter.on('pagination_refresh', function () {
            _this.forceUpdate();
          });
        }
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handlePageChange", function (currentPage) {
        if (_this.grid) {
          _this.grid.core.setCurrentPage(currentPage);
        }
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderPagination", function (grid) {
        var core = grid.core;

        if (!_this.grid && grid) {
          _this.grid = grid;
        }

        var children = _this.props.children;
        var pageData = core.getPageData();
        var total = pageData.total,
            pageSize = pageData.pageSize;
        var totalPage = Math.ceil(total / pageSize);

        if (total === 0 || totalPage === 1) {
          return null;
        }

        var otherProps = (0, _objectSpread2.default)({}, _this.props, pageData, {
          onChange: _this.handlePageChange
        });
        delete otherProps.children;
        var element = null;

        if (_react.default.isValidElement(children)) {
          element = _react.default.cloneElement(children, otherProps);
          return _react.default.createElement("div", {
            className: "pagination-wrapper"
          }, element);
        }

        return null;
      });
      return _this;
    }

    (0, _createClass2.default)(InnerPg, [{
      key: "render",
      value: function render() {
        return _react.default.createElement(_context.Consumer, null, this.renderPagination);
      }
    }]);
    return InnerPg;
  }(_react.default.Component);

  (0, _defineProperty2.default)(InnerPg, "propTypes", {
    children: _propTypes.default.element
  });
  (0, _defineProperty2.default)(InnerPg, "defaultProps", {});

  function Pify(Com) {
    return function Pagination(props) {
      var children = props.children,
          others = (0, _objectWithoutProperties2.default)(props, ["children"]);
      return _react.default.createElement(InnerPg, others, _react.default.createElement(Com, null, children));
    };
  }

  var _default = Pify;
  _exports.default = _default;
});